// extracted by mini-css-extract-plugin
export default {"root":"mI5BXi"};